"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(_ref) {
  var assetId = _ref.assetId,
      thumbnailUrl = _ref.thumbnailUrl;

  if (!thumbnailUrl) {
    return {
      assetId: assetId,
      hideFileTypeIcon: true
    };
  }

  return {
    assetId: void 0,
    asset: {
      metaData: JSON.stringify({
        type: 'image/jpeg'
      }),
      assetFiles: {
        ORIGINAL: {
          type: 'ORIGINAL',
          sourceUrl: thumbnailUrl
        }
      }
    },
    hideFileTypeIcon: true
  };
};

exports.default = _default;